<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">طلبات إدارة الاملاك</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إدارة الاملاك</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--FILTER-->
        <div v-if="checkAccess('management_request_create')" class="row">
          <div class="col text-end">
            <router-link to="/managementReqs/create" class="btn btn-primary">
              <i class="bi bi-plus-circle me-1"></i> إضافة طلب إدارة أملاك
            </router-link>
          </div>
        </div>
        <div class="card shadow card-warning card-outline mt-5">
          <div class="card-header">
            <button
              class="filter-btn w-100 text-start collapse-toggle"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#filterCard"
              aria-expanded="false"
              aria-controls="filterCard"
            >
              <i class="fa-solid fa-magnifying-glass"></i> بحث وتصفية
            </button>
          </div>

          <div class="collapse" id="filterCard">
            <form action="" @submit.prevent="filterSubmit">
              <div class="card-body">
                <div class="row">
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchName" class="form-control" placeholder="الاسم">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <input type="text" v-model="searchMobile" class="form-control" placeholder="رقم الجوال">
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchRegion" @change="getCitiesList">
                      <option :value="null">المنطقة</option>
                      <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select ref="citiesSelect" class="form-control" v-model="searchCity">
                      <!-- <option :value="null">المدينة</option> -->
                      <option v-for="r in citiesList" :value="r.id" :key="r.id">{{ r.name }}</option>
                    </select>
                  </div>
                  <div class="col-6 col-sm-3 mb-3">
                    <select class="form-control" v-model="searchStatus">
                      <option :value="null">حالة الطلب</option>
                      <option v-for="(val, key) in statusTranslate" :value="key" :key="key">{{ val }}</option>
                    </select>
                  </div>
                  <div 
                    class="d-flex align-items-center justify-content-between p-2 mb-2 rounded border"
                    @click="showDateFilter = !showDateFilter"
                    style="cursor:pointer; transition:0.3s;"
                    :class="showDateFilter ? 'bg-light border-primary' : ''"
                  >
                    <div class="d-flex align-items-center gap-2">
                      <i class="bi bi-calendar fs-5 text-primary"></i>
                      <span class="fw-bold">تاريخ الإنشاء</span>
                    </div>
                    <div>
                      <i :class="showDateFilter ? 'bi bi-chevron-up' : 'bi bi-chevron-down'"></i>
                    </div>
                  </div>
                  <div v-if="showDateFilter" class="row">
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">من تاريخ</label>
                      <input type="date" v-model="searchDateFrom" class="form-control">
                    </div>
                    <div class="col-6 col-sm-3 mb-3">
                      <label class="form-label">إلى تاريخ</label>
                      <input type="date" v-model="searchDateTo" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col text-end">
                    <button type="submit" class="btn btn-warning btn-sm"><i class="fa-solid fa-filter"></i> بحث وتصفية</button> 
                    <button type="button" class="btn btn-light btn-sm ms-3" @click.prevent="clearFilter"><i class="fa-solid fa-filter-circle-xmark"></i> إلغاء</button> 
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <!--begin::Row-->
        <div class="row">
          <div class="col">
            <div class="card card-secondary card-outline mb-4 mt-5">
              <div class="card-header d-flex align-items-center">
                <div class="card-title mb-0">طلبات إدارة الاملاك</div>
                  <span v-if="countRows > 0"
                    class="badge rounded-pill bg-primary fs-6 px-3 py-2 ms-auto"> 
                    عدد النتائج ( {{ countRows }} )</span>
              </div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <div class="card-body">
                <mainLoader v-if="mainLoading" />
                <div v-else class="row">
                  <div class="col">
                    <div class="table-responsive">
                      <table class="table table-striped">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>مقدم الطلب</th>
                            <th>الاسم</th>
                            <th>الجوال</th>
                            <th>الحالة</th>
                            <th>تاريخ الإنشاء</th>
                            <th>العمليات</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(row, indx) in rows" :key="row.id">
                            <td>{{ row.id }}</td>
                            <td>{{ (row.User)? row.User.name : 'غير معروف' }}</td>
                            <td>{{ row.name }}</td>
                            <td>{{ row.mobile }}</td>
                            <td>{{ statusTranslate[row.status] }}</td>
                            <td>{{ $shortDate(row.createdAt) }}</td>
                            <td>
                              <router-link :to="`/managementReqs/update/${row.id}`" class="btn btn-light btn-sm me-3">
                                <i v-if="checkAccess('management_request_update')" class="bi bi-pencil-square"></i>
                                <i v-else class="fa-regular fa-eye"></i>
                              </router-link>
                              <button v-if="checkAccess('management_request_delete')" class="btn btn-danger btn-sm" @click="deleteRow(row.id, indx)"><i class="bi bi-trash"></i></button>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer">
                <div class="row">
                  <div class="col">
                    <ul class="pagination">
                      <li v-if="currentPage > 1" class="page-item"><a class="page-link" href="#" @click.prevent="prevPage()">السابق</a></li>
                      <li v-for="p in pages" :key="p" class="page-item">
                        <a v-if="p == currentPage" class="page-link active" href="javascript:void(0)">{{ p }}</a>
                        <a v-else class="page-link" href="javascript:void(0)" @click="goToPage(p)">{{ p }}</a>
                      </li>
                      <li v-if="rows.length >= 30" class="page-item"><a class="page-link" href="#" @click.prevent="nextPage()">التالي</a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast, checkAccess } from '@/helpers/tools';
import $ from 'jquery';
window.$ = $;
window.jQuery = $;
import 'select2';
import 'select2/dist/css/select2.min.css';

export default {
  name: 'ManagementReqs',
  data(){
    return {
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rows: [],
      currentPage: parseInt(this.$route.query.page) || 1,
      pages: [],
      statusTranslate: {},
      regionsList: [],
      citiesList: [],
      searchName: this.$route.query.name || '',
      searchMobile: this.$route.query.mobile || '',
      searchStatus: this.$route.query.status || null,
      searchRegion: this.$route.query.region || null,
      searchCity: this.$route.query.city || null,
      searchDateFrom: this.$route.query.dateFrom || null,
      searchDateTo: this.$route.query.dateTo || null,
      showDateFilter: false, 
      countRows: 0,
    }
  },
  methods: {
    checkAccess, 
    getList(){
      this.mainLoading = true;
      this.hasError = false;
      let urlQuery = [`page=${this.currentPage}`];
      if(this.searchName.trim() != '')
        urlQuery.push(`name=${this.searchName.trim()}`);
      if(this.searchMobile.trim() != '')
        urlQuery.push(`mobile=${this.searchMobile.trim()}`);
      if(this.searchStatus !== null)
        urlQuery.push(`status=${this.searchStatus}`);
      if(this.searchRegion)
        urlQuery.push(`regionId=${this.searchRegion}`);
      if(this.searchCity)
        urlQuery.push(`cityId=${this.searchCity}`);

      if(this.searchDateFrom)
        urlQuery.push(`dateFrom=${this.searchDateFrom}`);
      if(this.searchDateTo)
        urlQuery.push(`dateTo=${this.searchDateTo}`);

      this.$router.replace({ query: {
        page: this.currentPage,
        ...(this.searchName !== null && this.searchName !== '' && this.searchName !== false ? { name: this.searchName } : {}),
        ...(this.searchMobile !== null && this.searchMobile !== '' && this.searchMobile !== false ? { mobile: this.searchMobile } : {}),
        ...(this.searchStatus !== null && this.searchStatus !== '' && this.searchStatus !== false ? { status: this.searchStatus } : {}),
        ...(this.searchRegion !== null && this.searchRegion !== '' && this.searchRegion !== false ? { region: this.searchRegion } : {}),
        ...(this.searchCity !== null && this.searchCity !== '' && this.searchCity !== false ? { city: this.searchCity } : {}),
        ...(this.searchDateFrom ? { dateFrom: this.searchDateFrom } : {}),
        ...(this.searchDateTo ? { dateTo: this.searchDateTo } : {}),
      }}).catch(() => {});

      this.$http.get(`/api/admin/managementReq/list?${urlQuery.join('&')}`).then(({data}) => {
        this.rows = data.rows;
        this.statusTranslate = data.statusChioces;
        this.regionsList = data.regionsList;
        this.pages = data.pages ?? [this.currentPage];
        this.countRows = data.countRows ?? 0;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    async deleteRow(id, index){
      const deletePrompt = await this.$swal.fire({
        title: "هل تريد تأكيد حذف السجل ، لا يمكن استعادته مرة اخرى ؟",
        showCancelButton: true,
        confirmButtonText: "حذف",
        cancelButtonText: "إلغاء",
        confirmButtonColor: '#dc3741',
      });
      
      if (deletePrompt.isConfirmed) {
        this.$http.delete(`/api/admin/managementReq/delete/${id}`).then(({data}) => {
          let buffer = this.rows;
          buffer.splice(index, 1);
          this.rows = buffer;
          // this.rows.splice(index, 1);
          toast('تم الحذف بنجاح', 'success');
        }).catch(err => {
          toast('غير قادر على الحذف');
        });
      }
    },
    getCitiesList(){
      this.citiesList = [];
      this.searchCity = null;
      if(!this.searchRegion){
        this.$nextTick(() => this.applySelect2Cities());
        return;
      }
      this.$http
        .get(`/api/admin/cities/list?regionId=${this.searchRegion}&all=1`)
        .then(({ data }) => {
          this.citiesList = data.cities;
          this.$nextTick(() => this.applySelect2Cities());
        })
        .catch(() => {});
    },
    nextPage(){
      this.currentPage += 1;
      this.getList();
    },
    prevPage(){
      this.currentPage -= 1;
      this.getList();
    },
    goToPage(num){
      this.currentPage = num;
      this.getList();
    },
    filterSubmit(){
      this.currentPage = 1;
      this.getList();
    },
    clearFilter(){
      this.currentPage = 1;
      this.searchName = '';
      this.searchMobile = '';
      this.searchStatus = null;
      this.searchRegion = null;
      this.searchCity = null;
      this.searchDateFrom = null;
      this.searchDateTo = null;
      this.citiesList = []; 
      this.$router.replace({ query: {} }).catch(() => {});
      this.getList();
    },
    applySelect2Cities(){
      const myInstance = this;
      if(!this.$refs.citiesSelect){
        setTimeout(() => {
          this.applySelect2Cities();
        }, 200);
        return;
      }
      $(this.$refs.citiesSelect).select2({width: '100%', placeholder: "المدينة"})
      .on("change", function () {
        myInstance.searchCity = $(this).val();
      });
    },
  },
  created(){
    this.getList();
  }
}
</script>